<template>
  <div class="sms-notification-creator">
    <b-row>
      <b-col md="6">
        <p>
          <strong>Nadawca:</strong>
          <b-form-select id="sender" :plain="true" :options="senderOptions" v-model="notification.sender" @click="currentInput = $refs.tel"/>
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <p>
          <strong>Nr tel. odbiorcy:</strong> <b-form-input ref="tel" v-model="notification.recipient" @click="currentInput = $refs.tel"/>
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <p>
          <strong>Treść:</strong>
          <b-form-textarea v-model="notification.messageTemplate.content" ref="content" @click="currentInput = $refs.content"/>
        </p>
      </b-col>
      <b-col md="12">
        <label><i class="fa fa-info-circle" title=""></i> Dostępne zmienne:</label>
        <br/>
        <span v-bind:key="i" v-for="(variable, i) in variables">
          <b-badge @click="copyVariable(variable)" variant="success" class="variable rounded-pill cursor-pointer">{{ variable }}</b-badge>&nbsp;
        </span>
      </b-col>
    </b-row>
    <hr>
    <b-button variant="primary" class="float-right" @click="saveNotification()">{{ this.initNotification ? `Zapisz` : `Utwórz` }}</b-button>
  </div>
</template>
<script>

import inputHelper from '../../inputHelper'
import variablesHelper from '../variablesHelper'

export default {
  props: ['initNotification', 'variables'],
  components: {},
  data () {
    return {
      notification: this.initializeNotification(),
      currentInput: null,
      senderOptions: [
        { text: 'Leadzard', value: 'Leadzard' },
        { text: 'Octamedia', value: 'Octamedia' },
        { text: 'Synteza OZE', value: 'SYNTEZA OZE' }
      ],
      newField: this.empty()
    }
  },
  created () {
  },
  name: 'c-sms-notification-creator',
  methods: {
    initializeNotification () {
      if (this.initNotification) {
        return JSON.parse(JSON.stringify(this.initNotification))
      }
      return this.empty()
    },
    empty () {
      return {
        sender: 'Octamedia',
        recipient: null,
        messageTemplate: {
          content: null,
          emptyVariableMessage: null
        }
      }
    },
    saveNotification () {
      const invalidVariables = variablesHelper.getInvalidVariablesInFields(this.variables, [
        this.notification.messageTemplate.content,
        this.notification.recipient
      ])
      if (invalidVariables.length > 0) {
        this.$notify({ group: 'notify', type: 'error', title: 'Wykryto niedozwolone zmienne', text: invalidVariables.join(', ') })
        return
      }
      this.$emit('saved', this.notification)
    },
    async copyVariable (variable) {
      if (!this.currentInput) return
      inputHelper.copyTextToInput(this.currentInput, variable)
    }
  }
}
</script>
